import React from "react";
import "./Our_Certificates.css";
import Common_title from "../../common-components/common_title/Common_title";

const Our_Certificates = () => {
  const Certificates = [
    {
      img: "/assets/images/about_us/certificates/img-1.jpeg",
    },
    {
      img: "/assets/images/about_us/certificates/img-2.jpeg",
    },
    {
      img: "/assets/images/about_us/certificates/img-3.jpeg",
    },
  ];
  return (
    <section className="certificate_section">
      <div className="container">
        <div className="certificate_title_holder">
          <Common_title text="⚓ OUR CERTIFICATES" />
        </div>
        <div className="certificates_img_holder">
          <div className="row align-items-center justify-content-center g-4">
            {Certificates.map((items, index) => (
              <div className="col-lg-4 col-md-4 col-sm-4 col-10" key={index}>
                <img
                  src={items.img}
                  className="certificates_img"
                  alt="certificates-img"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Certificates;
